export const PASSWORD_MIN_LENGTH = 8;

const STRENGTH_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

export function meetsPasswordStrength(password: string | null | undefined): boolean {
  if (!password) return false;
  return STRENGTH_PATTERN.test(password);
}
